import React from 'react'
import './JustForYouPackage.scoped.scss'
import { Check } from "lucide-react"

const JustForYouPackage = ({ data, onClickToPage }) => {
  return (
    <div className='just-for-you-package'>
      <div className='package-header'>
        <h2 className='package-title'>Just for you</h2>
      </div>

      <div className="package-content">
        {data?.map(
          (item, index) =>
            item.PackageType === 6 && (
              <div key={index} className="package-item">
                <div className="just-for-you-package-card">
                  <div className="card-header">
                    <h3 className="plan-title">{item.PackageName}</h3>
                    <div className="credit-info">
                      <span className="credit-amount">{item.Packagetotal_message.toLocaleString()}</span>
                      <span className="credit-label">Credit</span>
                    </div>
                    <div className="price-per-credit">{item.PackagePrice_per_credit} ฿/credit</div>
                  </div>
                  <div className="card-body">
                    <div className="total-price">฿ {item.Packagetotal_price.toLocaleString()}</div>
                    <div className="features-list">
                      <div className="feature-item">
                        <Check className="check-icon" />
                        <span>Credit period : {item.Package_Packageexpire}</span>
                      </div>
                      <div className="feature-item">
                        <Check className="check-icon" />
                        <span>Report : {item.Package_Reportexpire}</span>
                      </div>
                      <div className="feature-item">
                        <Check className="check-icon" />
                        <span>SMS Qty : {item.Packagetotal_message.toLocaleString()}</span>
                      </div>
                      <div className="feature-item">
                        <Check className="check-icon" />
                        <span>Sender name : {item.Package_Sender}</span>
                      </div>
                    </div>
                    <div className='package-btn'>
                      <button
                        className="buy-now-btn"
                        onClick={() => {
                          let pid = `${item.PackageId}|${item.Packagetotal_price}|special`;
                          onClickToPage("default", pid)
                        }}
                      >Buy now</button>
                    </div>
                  </div>
                </div>
              </div>
            ),
        )}
      </div>
    </div>
  )
}

export default JustForYouPackage